import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Row, Col, Input, Select, Button, Checkbox } from 'antd';
const Option = Select.Option;

@inject('store')
@observer
export class MHFormComponent extends Component {
    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let providers =
                    { ...this.props.store.botStore.currentConfiguration.signal_providers } || {};
                providers.mh = values;
                this.props.store.botStore.updateConfig({ signal_providers: providers });
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                <div>
                    Ensure you have set your client key on the Mining Hamster website to{' '}
                    <b>2W4dDJFJqB0dseJmSjuZk9IKiin9187U</b>
                </div>
                <Row gutter={24}>
                    <Col md={3}>
                        <Form.Item label="Enable Service">
                            {getFieldDecorator('enabled', {
                                valuePropName: 'checked',
                                initialValue: false
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>

                    <Col md={8}>
                        <Form.Item label="Buy &amp; Sell">
                            {getFieldDecorator('strategy_id', {})(
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                    optionFilterProp="name"
                                >
                                    {this.props.store.strategyStore.signal
                                        .slice()
                                        .sort((a, b) => {
                                            if (a.name < b.name) return -1;
                                            if (a.name > b.name) return 1;
                                            return 0;
                                        })
                                        .map(s => {
                                            return (
                                                <Option value={s.id} key={s.id}>
                                                    {s.name}
                                                </Option>
                                            );
                                        })}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={4}>
                        <Form.Item label="Enable sell signals">
                            {getFieldDecorator('sell_signal_enabled', {
                                valuePropName: 'checked',
                                initialValue: true
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>

                    <Col md={12}>
                        <Form.Item label="Api Key" required={true}>
                            {getFieldDecorator('api_key', {
                                rules: [{ required: true, message: 'Field is required' }]
                            })(<Input.Password />)}
                        </Form.Item>
                    </Col>
                </Row>

                <div style={{ textAlign: 'right' }}>
                    <Button onClick={this.handleSubmit.bind(this)} type="primary">
                        Save
                    </Button>
                </div>
            </div>
        );
    }
}

export const MHForm = Form.create({
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(k => {
            data[k] = Form.createFormField({ value: props.data[k] });
        });
        return data;
    }
})(MHFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Bot/SignalsView/MH/form.js